module.exports = __webpack_public_path__ + "img/insta-3.2004993e.png";